import axiosService from '@/services/axios/axios.service';

const BASE_URL = '/setting';

export interface Setting {
    key: string;
    value: any;
    description?: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface ApiResponse<T> {
    data: T;
    message: string;
    status: number;
}

export interface SettingsResponse {
    settings: Setting[];
    appVersion: string;
    downloadUrl: string;
}

export const settingApi = {
    // Get all settings
    getAll: async (): Promise<NonNullable<SettingsResponse>> => {
        const res = await axiosService.get(BASE_URL);
        return res.data;
    },

    // Get setting by key
    get: async (key: string): Promise<NonNullable<Setting>> => {
        const res = await axiosService.get(`${BASE_URL}/${key}`);
        return res.data;
    },

    // Create or update setting
    set: async (
        key: string,
        value: any,
        description?: string
    ): Promise<NonNullable<Setting>> => {
        const res = await axiosService.post(BASE_URL, {
            key,
            value,
            description,
        });
        return res.data;
    },

    // Update value and description
    update: async (
        key: string,
        value: any,
        description?: string
    ): Promise<NonNullable<Setting>> => {
        const res = await axiosService.patch(`${BASE_URL}/${key}`, {
            value,
            description,
        });
        return res.data;
    },

    // Toggle setting on/off
    toggleActive: async (
        key: string,
        isActive: boolean
    ): Promise<NonNullable<Setting>> => {
        const res = await axiosService.patch(
            `${BASE_URL}/${key}/active`,
            null,
            {
                params: { isActive },
            }
        );
        return res.data;
    },

    // Delete setting
    remove: async (key: string): Promise<NonNullable<Setting>> => {
        const res = await axiosService.delete(`${BASE_URL}/${key}`);
        return res.data;
    },
};

export default settingApi;
